// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"a4f03f85","586":"85ac715d","842":"69de6afc","988":"f28df7ce"}[chunkId] + ".chunk.css";
};